module.exports = __webpack_public_path__ + "static/media/bcsgQAScreen3.38467870.jpg";